import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Article from "../../components/Article/Article";
import Footer from "../../components/Footer/Footer";
import "./News.css";

function News() {
  const [articles, setArticles] = useState([]);
  const [subreddit, setSubreddit] = useState("football");

  useEffect(() => {
    fetch("https://www.reddit.com/r/" + subreddit + ".json").then((res) => {
      if (res.status !== 200) {
        console.log("ERRRRROOOOR");
        return;
      }

      res.json().then((data) => {
        if (data !== null) {
          setArticles(data.data.children);
        }
      });
    });
  }, [subreddit]);
  return (
    <div>
      <Navbar />
      <br /> <br />
      <input
        type="text"
        className="input"
        placeholder="Football topic news"
        value={subreddit}
        onChange={(e) => setSubreddit(e.target.value)}
      />
      <br /> <br />
      <div className="articles">
        {articles !== null
          ? articles.map((article, index) => (
              <Article key={index} article={article.data} />
            ))
          : ""}
      </div>
      <br /> <br />
      <Footer />
    </div>
  );
}

export default News;
